import React from "react"
import { useDispatch } from "react-redux"
import Link from "next/link"
import CustomImage from "@/main/customImage"
import { Card, Row, Col, Button } from "react-bootstrap"

import {
    toggleMakeEnquiryModal,
    setMakeEnquiryProperty,
} from "@/slices/makeEnquiryModalSlice"

function PropertyCardList({ property, priority }) {
    const dispatch = useDispatch()

    const formatter = new Intl.NumberFormat("en", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
    })

    return (
        <Card className="mb-5 p-0 btn-card">
            <Row className="mobile-marg-0">
                <Col md={6} lg={7} xl={8} className="property-img-col">
                    <Link href={"/properties/" + property.property_ref}>
                        <a>
                            <Row className="g-0">
                                <Col xs={12} xl={9}>
                                    <div className="property-img">
                                        <CustomImage
                                            src={
                                                property.images[0]?.imgix_url ||
                                                "https://webb-jenkins-static-164679926.imgix.net/placeholder.svg"
                                            }
                                            alt={`Property ${property.property_ref} main`}
                                            layout="fill"
                                            objectFit="cover"
                                            objectPosition="center"
                                            sizes="50vw"
                                            priority={priority}
                                        />
                                        {property.status_id === 1 ? (
                                            <Row className="mx-0 h-100 align-items-end sstc-old-browser">
                                                <Col
                                                    xs="auto"
                                                    className="z-index-1 bg-danger sstc-tag"
                                                >
                                                    <span className="text-white">
                                                        Sold STC
                                                    </span>
                                                </Col>
                                            </Row>
                                        ) : property.status_id === 5 ? (
                                            <Row className="mx-0 h-100 align-items-end sstc-old-browser">
                                                <Col
                                                    xs="auto"
                                                    className="z-index-1 bg-danger sstc-tag"
                                                >
                                                    <span className="text-white">
                                                        Let agreed
                                                    </span>
                                                </Col>
                                            </Row>
                                        ) : null}
                                    </div>
                                </Col>
                                <Col xs={12} xl={3}>
                                    <Row className="g-0 ps-xl-1 pt-1 pt-xl-0">
                                        <Col
                                            xs={4}
                                            xl={12}
                                            className=" property-img1"
                                        >
                                            <div className="property-img">
                                                {property.images[1]
                                                    ?.imgix_url ? (
                                                    <CustomImage
                                                        src={
                                                            property.images[1]
                                                                ?.imgix_url
                                                        }
                                                        alt={`Property ${property.property_ref} second`}
                                                        layout="fill"
                                                        objectFit="cover"
                                                        objectPosition="center"
                                                        sizes="25vw"
                                                    />
                                                ) : null}
                                            </div>
                                        </Col>
                                        <Col
                                            xs={4}
                                            xl={12}
                                            className="property-img2"
                                        >
                                            <div className="property-img">
                                                {property.images[2]
                                                    ?.imgix_url ? (
                                                    <CustomImage
                                                        src={
                                                            property.images[2]
                                                                ?.imgix_url
                                                        }
                                                        alt={`Property ${property.property_ref} third`}
                                                        layout="fill"
                                                        objectFit="cover"
                                                        objectPosition="center"
                                                        sizes="25vw"
                                                    />
                                                ) : null}
                                            </div>
                                        </Col>
                                        <Col
                                            xs={4}
                                            xl={12}
                                            className="property-img3"
                                        >
                                            <div className="property-img">
                                                {property.images[3]
                                                    ?.imgix_url ? (
                                                    <CustomImage
                                                        src={
                                                            property.images[3]
                                                                ?.imgix_url
                                                        }
                                                        alt={`Property ${property.property_ref} fourth`}
                                                        layout="fill"
                                                        objectFit="cover"
                                                        objectPosition="center"
                                                        sizes="25vw"
                                                    />
                                                ) : null}
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </a>
                    </Link>
                </Col>

                <Col md={6} lg={5} xl={4}>
                    <Card.Body className="d-flex flex-column h-100 pb-0 pe-md-5 pt-lg-5 pt-xl-4 pt-xxl-5 ">
                        <Link href={"/properties/" + property.property_ref}>
                            <a>
                                <Card.Title className="btn-card">
                                    <span className="text-normal text-sm">
                                        {property.trans_type_id === 1 &&
                                            property.residential_sales_details &&
                                            property.residential_sales_details
                                                ?.price_qualifier !==
                                                "None" && (
                                                <>
                                                    {
                                                        property
                                                            .residential_sales_details
                                                            ?.price_qualifier
                                                    }
                                                    &nbsp; &nbsp; | &nbsp;
                                                    &nbsp;
                                                </>
                                            )}
                                        {property.property_ref}
                                    </span>
                                    <span className="h3 d-block mb-3">
                                        {formatter.format(property.price)}
                                        {property.trans_type_id === 2 &&
                                        property.residential_lettings_details
                                            ?.let_rent_frequency === 0
                                            ? " pw"
                                            : property
                                                    .residential_lettings_details
                                                    ?.let_rent_frequency === 1
                                              ? " pcm"
                                              : property
                                                      .residential_lettings_details
                                                      ?.let_rent_frequency === 2
                                                ? " per Quarter"
                                                : property
                                                        .residential_lettings_details
                                                        ?.let_rent_frequency ===
                                                    3
                                                  ? " pa"
                                                  : ""}
                                    </span>
                                    <h2 className="h4">
                                        {property.display_address}
                                    </h2>
                                    <div className="d-flex mb-3 mb-sm-2 mb-md-3">
                                        <div>
                                            <CustomImage
                                                src={
                                                    "https://webb-jenkins-static-164679926.imgix.net/icons/bed.svg"
                                                }
                                                alt="Bed icon"
                                                height={16}
                                                width={28}
                                                className="me-1"
                                            />

                                            <span className="me-5 text-normal text-sm">
                                                {property.bedrooms} Bedroom
                                            </span>
                                        </div>

                                        {property.bathrooms > 0 && (
                                            <div>
                                                <CustomImage
                                                    src={
                                                        "https://webb-jenkins-static-164679926.imgix.net/icons/bath.svg"
                                                    }
                                                    alt="Bath icon"
                                                    height={16}
                                                    width={28}
                                                    className="me-1"
                                                />
                                                <span className="text-normal text-sm">
                                                    {property.bathrooms}{" "}
                                                    Bathroom
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </Card.Title>
                                <div className="btn-card">
                                    <p className="d-none d-xl-block d-xxl-none text-sm">
                                        {property.summary.length > 75
                                            ? property.summary.substring(
                                                  0,
                                                  75,
                                              ) + "..."
                                            : property.summary}
                                    </p>
                                    <p className="d-none d-lg-inline d-xl-none d-xxl-inline text-sm">
                                        {property.summary.length > 200
                                            ? property.summary.substring(
                                                  0,
                                                  200,
                                              ) + "..."
                                            : property.summary}
                                    </p>
                                </div>
                            </a>
                        </Link>

                        <Row className="d-none d-md-flex mt-3 mt-xl-4 align-content-end flex-grow-1">
                            <Col xs={6} className="d-flex align-self-end">
                                <Col
                                    href={
                                        "/properties/" + property.property_ref
                                    }
                                    as={Link}
                                    xs={12}
                                >
                                    <Col
                                        xs={12}
                                        as={Button}
                                        variant="outline-warning"
                                        className="px-3 rounded-0 mt-3 mt-md-0"
                                    >
                                        <span className="m-0 text-sm text-warning">
                                            More details
                                        </span>
                                    </Col>
                                </Col>
                            </Col>
                            <Col xs={6} className=" d-flex align-self-end">
                                <Col
                                    xs={12}
                                    as={Button}
                                    variant="warning"
                                    className="px-3 rounded-0"
                                    onClick={() => {
                                        dispatch(toggleMakeEnquiryModal(true))
                                        dispatch(
                                            setMakeEnquiryProperty(property),
                                        )
                                    }}
                                >
                                    <span className="m-0 text-sm text-white">
                                        Make enquiry
                                    </span>
                                </Col>
                            </Col>
                        </Row>
                    </Card.Body>
                </Col>
            </Row>
            <Row className="d-none d-sm-flex d-md-none mt-md-6 mx-3 mb-3">
                <Col xs={12} sm={6} className="d-flex align-self-end">
                    <Col
                        href={"/properties/" + property.property_ref}
                        as={Link}
                        xs={12}
                    >
                        <Col
                            xs={12}
                            as={Button}
                            variant="outline-warning"
                            className="px-3 rounded-0 mt-3 mt-md-0"
                        >
                            <span className="m-0 text-sm text-warning">
                                More details
                            </span>
                        </Col>
                    </Col>
                </Col>
                <Col xs={12} sm={6} className="d-none d-sm-flex align-self-end">
                    <Col
                        xs={12}
                        as={Button}
                        variant="warning"
                        className="px-3 rounded-0"
                        onClick={() => {
                            dispatch(toggleMakeEnquiryModal(true))
                            dispatch(setMakeEnquiryProperty(property))
                        }}
                    >
                        <span className="m-0 text-sm text-white">
                            Make enquiry
                        </span>
                    </Col>
                </Col>
            </Row>
        </Card>
    )
}

export default PropertyCardList
